import { objectToSnakeCase, objectToCamelCase } from '../utils'

import AttributeAPI from './api'

export default class Attribute {
  static api = AttributeAPI.create(Attribute)

  constructor({ name = null, id = null, group = null } = {}) {
    Object.assign(this, {
      name,
      id,
      group,
    })
  }

  copy() {
    return new Attribute(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Attribute(data)
  }

  static fromAPI(json = {}) {
    return new Attribute(objectToCamelCase(json))
  }

  /* Prep data for the API. Can elect to include */
  static toAPI(attribute, fields = []) {
    let data = {}
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = attribute[field]
      })
    } else {
      data = attribute
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Attribute)) {
      throw Error(`${name} must be an instance of the Attribute class.`)
    }
  }
}
